import { Form, Input, Icon, Button, notification } from 'antd'
import React from 'react'
import polyglot from '../Translator'
import { LoginLink } from './Login'
import { FormProps } from 'antd/lib/form'
import { connect } from 'react-redux'
import { AppTranslations } from '../Translations'
import { getValidatedFormValues } from '../Utils/FormUtils'
import Axios from 'axios'
import { APIPaths } from '../AppRoutes'
import ErrorMessages from '../DTO/ErrorMessages'

const translations = {
  forgotPW: {
    en: 'Forgotten password',
    fr: 'Mot de passe oublié'
  },
  send: {
    en: 'Send',
    fr: 'Envoyer'
  },
  sendLink: {
    en: 'We will send you a link to reset your password to the following email address:',
    fr: "Nous vous enverrons un lien pour réinitialiser votre mot de passe à l'adresse courriel suivante :"
  },
  backLogin: {
    en: 'Back to login',
    fr: 'Retour à la connexion'
  },
  linkExpires: {
    en: 'A password reset link has been sent to your mailbox. This link will expire in 24h. ',
    fr: 'Un lien de réinitialisation de mot de passe a été envoyé dans votre boite courriel. Ce lien expirera dans 24h.'
  },
  userNotFound: {
    en: 'User not found',
    fr: 'Utilisateur non trouvé.'
  },
  userNotFoundDesc: {
    en: 'The email address provided does not match any Redox user.',
    fr: "L'adresse courriel fournie ne correspond à aucun utilisateur Redox."
  }
}

const ForgotPasswordForm = ({ onLogin, form }: Props) => {
  const sendForgot = async (e: React.FormEvent<any>) => {
    e.preventDefault()
    try {
      const values = await getValidatedFormValues<{ email: string }>(form)
      await Axios.post(APIPaths.RESET_PASSWORD, {
        email: values.email
      })

      notification.success({
        message: polyglot.tr(AppTranslations.success),
        description: polyglot.tr(translations.linkExpires)
      })
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.status === 404 &&
        error.response.data &&
        error.response.data.error === ErrorMessages.USER_NOT_FOUND
      ) {
        notification.error({
          message: polyglot.tr(translations.userNotFound),
          description: polyglot.tr(translations.userNotFoundDesc)
        })
      } else {
        console.error(error)
      }
    }
  }

  return (
    <Form onSubmit={sendForgot} style={{ width: '300px', marginTop: '100px', textAlign: 'center' }}>
      <h2>{polyglot.tr(translations.forgotPW)}</h2>
      <p>{polyglot.tr(translations.sendLink)}</p>
      <Form.Item>
        {form.getFieldDecorator('email', {
          rules: [
            {
              required: true,
              message: polyglot.t('provideEmail')
            },
            {
              type: 'email',
              message: polyglot.tr(AppTranslations.invalidEmail)
            }
          ]
        })(
          <Input prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder={polyglot.t('email')} />
        )}
      </Form.Item>
      <Button type="primary" style={{ width: '100%' }} htmlType="submit">
        {polyglot.tr(translations.send)} <Icon type="mail" />
      </Button>
      <LoginLink onClick={onLogin}>{polyglot.tr(translations.backLogin)}</LoginLink>
    </Form>
  )
}

interface Props extends FormProps {
  onLogin: () => void
}

export default connect(
  null,
  null
)(Form.create({ name: 'forgot_form' })(ForgotPasswordForm))
